import asap from '@js/asap.js';

asap('img[loading=lazy]', img => {
	img.style.opacity = 0;

	const anim = () => img.animate([{ opacity: 0 }, { opacity: 1 }], 1000)
        .addEventListener('finish', () => (img.style.opacity = ''));

    // if image cached or loads before asap fade in, else listen for load event.
    img.complete ? anim() : img.addEventListener('load', anim);
});